import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

/* Page Wrapper */

const PrivacySection = styled.section`
  padding: 120px 20px 80px;
  background: #ffffff;
`;

/* Content Wrapper */

const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
`;

/* Title */

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 20px;
`;

/* Section Title */

const SubTitle = styled.h2`
  font-size: 22px;
  margin-top: 35px;
  margin-bottom: 10px;
`;

/* Paragraph */

const Text = styled.p`
  line-height: 1.7;
  margin-bottom: 12px;
  color: #555;
`;

/* List */

const List = styled.ul`
  margin-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

const PrivacyPolicy = () => {
  return (
    <>
      <TopNavbar />

      <PrivacySection>
        <Wrapper>

          <Title>Privacy Policy</Title>

          <Text>
            Welcome to the EBK Thangamaligai website. Your privacy is important
            to us and we are committed to protecting the personal information
            you share with us. This Privacy Policy explains how we collect,
            use, store and protect your information when you use our website.
          </Text>

          <Text>
            EBK Thangamaligai reserves the right to update or modify this
            Privacy Policy at any time without prior notice. Users are advised
            to review this page periodically to stay informed about any
            changes.
          </Text>

          <SubTitle>1. Personal Information Collected</SubTitle>

          <Text>
            By using our website, you authorize EBK Thangamaligai to collect,
            store and use the information you provide while interacting with
            our website.
          </Text>

          <Text>The information we may collect includes:</Text>

          <List>
            <ListItem>Name</ListItem>
            <ListItem>Email Address</ListItem>
            <ListItem>Phone Number</ListItem>
            <ListItem>Billing and Shipping Address</ListItem>
            <ListItem>Order details and purchase history</ListItem>
            <ListItem>Any information sent via email or contact forms</ListItem>
          </List>

          <Text>
            This information is collected only when voluntarily provided by
            users through registration, order placement, enquiry forms or
            other communication channels.
          </Text>

          <SubTitle>2. Cookies</SubTitle>

          <Text>
            Cookies are small pieces of information stored by your browser on
            your device. These cookies help us remember your preferences and
            improve your browsing experience on our website.
          </Text>

          <Text>
            EBK Thangamaligai uses cookies to analyse website traffic and
            enhance functionality. We do not use cookies to store sensitive
            personal information for external use.
          </Text>

          <SubTitle>3. Use of Collected Information</SubTitle>

          <Text>
            The information collected by EBK Thangamaligai may be used for the
            following purposes:
          </Text>

          <List>
            <ListItem>Processing and fulfilling customer orders</ListItem>
            <ListItem>Providing customer support and responding to enquiries</ListItem>
            <ListItem>Improving the performance and usability of the website</ListItem>
            <ListItem>Sending updates about new collections, offers or promotions</ListItem>
            <ListItem>Understanding user preferences and shopping behaviour</ListItem>
          </List>

          <Text>
            Users may unsubscribe from promotional emails at any time by using
            the unsubscribe option included in such communications.
          </Text>

          <SubTitle>4. Sharing of Information</SubTitle>

          <Text>
            EBK Thangamaligai does not sell, rent or trade your personal
            information to third parties.
          </Text>

          <Text>
            However, certain trusted third parties may have access to
            information when necessary to provide services such as:
          </Text>

          <List>
            <ListItem>Courier and delivery service providers</ListItem>
            <ListItem>Payment gateway or banking partners</ListItem>
            <ListItem>Website hosting or technical service providers</ListItem>
          </List>

          <Text>
            These third parties are authorized to use your information only
            for the purpose of completing the services requested by you.
          </Text>

          <SubTitle>5. Legal Disclosure</SubTitle>

          <Text>
            EBK Thangamaligai may disclose personal information if required to
            do so by law or when such disclosure is necessary to comply with
            legal obligations such as court orders, subpoenas, or government
            regulations.
          </Text>

          <SubTitle>6. Security of Information</SubTitle>

          <Text>
            We take reasonable security measures to protect your personal
            information from unauthorized access, misuse or disclosure.
            However, while we strive to protect your data, no method of
            transmission over the internet is completely secure.
          </Text>

          <SubTitle>7. Third-Party Websites</SubTitle>

          <Text>
            Our website may contain links to third-party websites for your
            convenience. Once you leave our website, the privacy policies of
            those websites will apply and EBK Thangamaligai will not be
            responsible for their privacy practices.
          </Text>

          <SubTitle>8. Your Consent</SubTitle>

          <Text>
            By using this website, you consent to the collection and use of
            your information as outlined in this Privacy Policy.
          </Text>

          <SubTitle>9. Updates to This Policy</SubTitle>

          <Text>
            EBK Thangamaligai reserves the right to modify or update this
            Privacy Policy at any time. Any changes will be posted on this
            page and will become effective immediately upon publication.
          </Text>

          <SubTitle>Contact Us</SubTitle>

          <Text>
            If you have any questions or concerns regarding this Privacy
            Policy, you may contact us through the website or reach us at:
          </Text>

          <Text>
            <strong>Email:</strong> support@ebkthangamaligai.com
          </Text>

        </Wrapper>
      </PrivacySection>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;